import Typography from "@mui/material/Typography";

export function DatasetDownload() {
    return <Typography variant='body2' color="text.secondary">
        10-, 30-, and 90-meter conterminous United States scale IC datasets can be
        downloaded <a
            href="https://console.cloud.google.com/storage/browser/index-of-connectivity"
            target="_blank"
            rel="noreferrer"
        >here</a> (requires google account).
    </Typography>
}

export default DatasetDownload;
